import { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { PageHeader } from "../../components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { PosService } from "../../services";
import { useAuth } from "../../store/AuthContext";
import { toast } from "sonner";
import { ArrowLeft, AlertTriangle } from "lucide-react";

export const CorrectionRequestPage = ({ cashierBasePath = "/cashier" } = {}) => {
  const { user } = useAuth();
  const { saleId } = useParams();
  const navigate = useNavigate();
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!reason.trim()) return toast.error("Please enter a reason");
    setBusy(true);
    try {
      await PosService.correctionRequest(saleId, { reason: reason.trim(), requestedByName: user.fullName });
      toast.success("Correction request submitted");
      navigate(`${cashierBasePath}/sales/${saleId}`);
    } catch (e) { toast.error(e?.response?.data?.message || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader
        title="Request correction"
        subtitle="Admins will review and approve or reject your request."
        actions={<Link to={`${cashierBasePath}/sales/${saleId}`}><Button variant="outline"><ArrowLeft className="h-4 w-4 mr-2" /> Back</Button></Link>}
      />
      <div className="bms-card p-6">
        <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg text-amber-800 text-sm">
          <AlertTriangle className="h-4 w-4 mt-0.5" />
          <p>If approved, the sale will be cancelled and stock restored to the original batches.</p>
        </div>
        <div className="mt-5">
          <Label className="text-xs text-slate-600">Reason for correction</Label>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={4} placeholder="e.g. Wrong bottle quantity entered" data-testid="correction-reason" />
        </div>
        <Button onClick={submit} disabled={busy} className="mt-4 bg-navy-800 hover:bg-navy-900 text-white" data-testid="correction-submit">
          {busy ? "Submitting…" : "Submit request"}
        </Button>
      </div>
    </div>
  );
};
